import { useMutation, useQueryClient } from "@tanstack/react-query";

import { Entity, EntityLevel, EntityType } from "../../../../types/types";

import { updateEntityProfile } from "../services/entityProfileService";

import { entityKeys } from "../queryKeys";

interface UpdateEntityProfileParams {
  entityId: number;
  about: string;
  mediaUrl: string;
  // name: string;
  name_ar: string;
  name_en: string;
  level: EntityLevel;
  type: EntityType;
  countryId: number;
  foundedYear: number;
  listEntry: number[];
}

export const useUpdateEntityProfile = () => {
  const queryClient = useQueryClient();

  return useMutation<Entity, Error, UpdateEntityProfileParams>({
    mutationFn: ({
      entityId,
      about,
      mediaUrl,
      // name,
      name_ar,
      name_en,
      level,
      type,
      countryId,
      foundedYear,
      listEntry,
    }: UpdateEntityProfileParams) => {
      return updateEntityProfile(entityId, {
        about,
        mediaUrl,
        level,
        type,
        countryId,
        foundedYear,
        listEntry,
        name_ar,
        name_en,
        // name,
      });
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["NetworkList"] });
      queryClient.invalidateQueries({ queryKey: ["EntityProfile"] });
      queryClient.invalidateQueries({ queryKey: ["userInfo"] });
      queryClient.invalidateQueries({ queryKey: entityKeys.details(String(variables.entityId)) });
      queryClient.invalidateQueries({ queryKey: entityKeys.all });
    },
  });
};
